const STORAGE_KEY = "ottkit.liveReactions.collapsed";

/**
 * Свёрнутая панель реакций запоминается в браузере зрителя. Это удобство,
 * а не состояние, которое обязано сохраниться: в приватном окне или при
 * заблокированном хранилище доступ бросает исключение, тогда действует
 * умолчание экрана.
 *
 * null: зритель ещё не выбирал (или хранилище недоступно), тогда панель
 * свёрнута на мобайле и раскрыта на десктопе.
 */
export function readPanelCollapsed(
  storage?: Pick<Storage, "getItem">,
): boolean | null {
  try {
    const value = (storage ?? window.localStorage).getItem(STORAGE_KEY);
    return value === null ? null : value === "1";
  } catch {
    return null;
  }
}

export function writePanelCollapsed(
  collapsed: boolean,
  storage?: Pick<Storage, "setItem">,
): void {
  try {
    (storage ?? window.localStorage).setItem(
      STORAGE_KEY,
      collapsed ? "1" : "0",
    );
  } catch {
    // Хранилище недоступно: выбор живёт до перезагрузки страницы.
  }
}
